//导航栏功能
$(".hr_nav").hover(function () {
    var index = $(this).index();
    if (index == 1) return;
    $('.main_mask').css({ height: '100vh' })
    $(`.hm_popup${index + 1}`).css({ height: eval(`$('.hm_popup${index + 1}')[0].scrollHeight`) })
}, function () {
    var index = $(this).index();
    if (index == 1) return;
    $('.main_mask').css({ height: '0' })
    $(`.hm_popup${index + 1}`).css({ "height": "0" })
})

$(".hm_popup").hover(function () {
    var index = $(this).index() + 1
    $('.main_mask').css({ height: '100vh' })
    $(this).css({ height: eval(`$('.hm_popup${index}')[0].scrollHeight`) })
}, function () {
    $(this).css({ height: '0' })
    $('.main_mask').css({ height: '0' })
})

var lastScrollTop = 0, wFlag = window.innerWidth > 750, productPage = false
$(function () {
    if (document.querySelector('.product_nav')) {
        productPage = true
    }
})
$(window).scroll(function () {
    var Top = $(window).scrollTop()
    if (productPage) {
        if(Top > 84){
            //product header
            $('.product_nav').css({ top: '0', transition: 'all 1s' })

        }else{
            $('.product_nav').css({ top: '-3.5rem', transition: 'none' })
        }
    }
    if (Top < lastScrollTop) {
        // 鼠标向上滑动
        if (Top > 1) {
            $('.To_top').fadeIn()
        } else {
            $('.To_top').fadeOut();
        }
    } else {
        $('.To_top').fadeOut();
    }
    lastScrollTop = Top;
})


//Mobile
var mliflag = true;
$('.menu_left').click(function () {
    if (mliflag) {
        $('.menu_line').css({ background: 'transparent' })
        $(this).addClass('menu_active')
        $('.Mhm_popup').css({ height: '96vh' })
    } else {
        $('.menu_line').css({ background: 'black' })
        $(this).removeClass('menu_active')
        $('.Mhm_popup').css({ height: '0' })
    }
    mliflag = !mliflag
})

$('.Mhm_popup .mp_item').click(function () {
    var Toheight = $(this).next('.mp_content')[0].scrollHeight
    var height = $(this).next('.mp_content').css('height')
    if (height == '0px') {
        $(this).children('.series_right').addClass('Ms_active')
        $(this).next('.mp_content').css({ height: `${Toheight}px` })
    } else {
        $(this).children('.series_right').removeClass('Ms_active')
        $(this).next('.mp_content').css({ height: '0' })
    }
})